export default "__VITE_ASSET__fB0sydq9LzIdCrzm1PcO1Q__";